import React from "react"
import { Stack, colors } from "@carrotfertility/carotene"
import { IlloUnderwaterPlants } from "components/views/atoms/Illustrations"
import { FormattedMessage } from "react-intl"

const NoInsurance = (): JSX.Element => {
  return (
    <Stack
      height="275px"
      width="100%"
      padding="medium"
      direction="column"
      borderRadius="8px"
      spacing="small"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: colors.base.pampas,
        "& > div": {
          height: "auto"
        }
      }}
    >
      <IlloUnderwaterPlants />
      <FormattedMessage defaultMessage="You have told us that you do not have health insurance" />
    </Stack>
  )
}

export default NoInsurance
